import { LoginType } from '../../api-types/models/LoginDto';

export function isBrunchLoginType(loginType: string | null): boolean {
    return loginType === LoginType.BRUNCH || loginType === LoginType.COACH;
}

export function isBrunchSession(
    loginType: string | null,
    userGroups: string[]
): boolean {
    return (
        isBrunchLoginType(loginType) ||
        userGroups.includes(LoginType.BRUNCH) ||
        userGroups.includes(LoginType.COACH)
    );
}
